import { Text } from "@pancakeswap/uikit"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { AppDispatch } from "state"
import { GetDataGiftCards, UseDetailBrand } from "state/giftCards"
import { fetchStatusScreen } from "state/giftCards/actions"
import { SUPPORT_CHAIN_GIFTCARDS } from "utils/wagmi"
import NotFoundBrand from "views/BrandDetails/components/NotFound"
import GiftCards from "views/GiftCards"

const GiftCardsPage = () => {
    const router = useRouter()
    const { brand, price, product, phoneNumber, newbrand } = router.query
    UseDetailBrand(brand?.toString(), newbrand?.toString())
    const { brandItem } = GetDataGiftCards()
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(fetchStatusScreen({isActiveScreen: 0}))
    },[dispatch])

    if(brandItem?.length === 0) {
        return <NotFoundBrand />
    }
    return <GiftCards price={price?.toString()} brand={brand?.toString()} product={product?.toString()} phoneNumber={phoneNumber?.toString()} newbrand={newbrand?.toString()} />
}

GiftCardsPage.chains = SUPPORT_CHAIN_GIFTCARDS

export default GiftCardsPage